import { Card } from '@/components/Card';
import { Flex } from '@/components/Grid';
import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { type AdItemType } from '@/resource/ad';
import { Fragment } from 'react';

export function CategoryList({ ad }: { ad: AdItemType }) {
  const overviewType = `market_${ad.type}s` as const;
  const categories = ad.categories.data;
  const activities = ad.activities.data;

  return (
    <Flex dir="column" gap={2}>
      {categories.map((category) => {
        const selected = activities.filter(
          ({ ad_category_id }) => ad_category_id === category.id
        );

        return (
          <Card key={category.id}>
            <Flex dir="column" gap={1}>
              <Flex dir="row" gap={2}>
                <Icon icon={category.icon} theme={1} />
                <h3>
                  <Link
                    to={{
                      type: overviewType,
                      filter: {
                        category_ids: [category.id],
                      },
                    }}
                  >
                    {category.name}
                  </Link>
                </h3>
              </Flex>

              {selected.length > 0 && (
                <p>
                  {selected.map((activity, index) => (
                    <Fragment key={activity.id}>
                      {index > 0 && ', '}
                      <Link
                        to={{
                          type: overviewType,
                          filter: {
                            category_ids: [category.id],
                            keyword: activity.name,
                          },
                        }}
                      >
                        {activity.name}
                      </Link>
                    </Fragment>
                  ))}
                </p>
              )}
            </Flex>
          </Card>
        );
      })}
    </Flex>
  );
}
